<template>
<!-- state切换button的状态 调用cancel()可以切换 -->
  <div class="home"> 
      <div class="frame-header"></div>
      <div class="frame-footer">
    <el-button  
         @click="goHome"
        :disabled="state" 
        class="hbt" 
        icon="el-icon-s-home" 
        type="text"
    ></el-button>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return {
      state: false,
    }
  },
  methods: {
    goHome(){
      this.state = true
      //这里是激活父组件的事件，因为子组件是不会冒泡到父组件上的，必须手动调用$emit
      //相对应父组件要在调用该组件的时候，将其挂载到上面
      this.$emit("goHome")
    },
    disable(){
      this.state = true
    },
    enable(){
      this.state = false
    }
  }
}
</script>
<style scoped>
    .home {
        position: absolute;
        height: 100%;
        left:2rem
    }
    .frame-header{
        height: 93% !important;
    }
    .frame-footer {
        height: 7% !important;
        display: flex;
    }
    .hbt {
        font-size: 3rem;
        padding: 0;
        z-index: 2000;
        align-self: center;
    }
</style>
